<script setup lang="ts">
import { RouterView } from 'vue-router'

import { useCharecterStore } from './stores/store'

const characterStore = useCharecterStore()
</script>

<template>
  <el-select v-model="characterStore.environment" placeholder="选择环境" style="margin-bottom: 20px;" @change="characterStore.changeEnvironment">
    <el-option v-for="value in characterStore.environments" :key="value.key" :label="value.label" :value="value.key" />
  </el-select>
  <RouterView />
</template>

<style scoped>

</style>
